import React from "react"

import SentryScopeSync from "~components/shared/sentry-scope-sync"
import AuthProvider from "~contexts/auth-provider"
import ApolloProvider from "~contexts/apollo-provider"
import { UserProvider } from "~contexts/user-provider"
import CourierInboxProvider from "~contexts/courier-inbox-provider"
import { InAppBrowserProvider } from "~contexts/in-app-browser-provider"
import ThemeProvider from "~contexts/theme-provider"
import { PortalEntitiesProvider } from "~contexts/outfitter-provider"
import { OutfitterAssistantProvider } from "~contexts/outfitter-assistant-provider"
import { PageLayoutProvider } from "~contexts/page-layout-provider"
import { CalendarControlsProvider } from "~contexts/calendar-controls-provider"
import PermissionsProvider from "~components/shared/permissions/permissions-provider"
import AppPromptGate from "~components/shared/app-prompts/app-prompt-gate"
import "swiper/css"
import "react-datepicker/dist/react-datepicker.css"
import "~styles/uploadcare.css"
import "~styles/react-datepicker.css"

interface Props {
    readonly element: React.ReactNode
}

export default function WrapRootElement({ element }: Props) {
    return (
        <ThemeProvider>
            <PageLayoutProvider>
                <AuthProvider>
                    <ApolloProvider>
                        <UserProvider>
                            <InAppBrowserProvider>
                                <CourierInboxProvider>
                                    <PortalEntitiesProvider>
                                        <SentryScopeSync>
                                            <PermissionsProvider>
                                                <OutfitterAssistantProvider>
                                                    <AppPromptGate />
                                                    <CalendarControlsProvider>
                                                        {element}
                                                    </CalendarControlsProvider>
                                                </OutfitterAssistantProvider>
                                            </PermissionsProvider>
                                        </SentryScopeSync>
                                    </PortalEntitiesProvider>
                                </CourierInboxProvider>
                            </InAppBrowserProvider>
                        </UserProvider>
                    </ApolloProvider>
                </AuthProvider>
            </PageLayoutProvider>
        </ThemeProvider>
    )
}
